module.exports = __webpack_public_path__ + "static/screenshot3-106d24c7dde4c64d57185d8331d8fc1d.png";